import * as React from "react";
import { Row, Col } from "antd";
import readManifest from "../../common/cms";
import QuiltedImageList from "../ImageList";
import { primaryHeaderColor } from "../../styles";
import { ContentWrapper, MiddleBlockSection } from "../MiddleBlock/styles";

// "https://s3.us-east-1.amazonaws.com/holinfrastructurestack-assetsb7c36b1b-np1bc4l3qvho/gallery/manifest.json"
function Gallery() {
  const [images, setImages] = React.useState([] as any[]); // TODO fix typing

  // TODO move s3 asset url to constants
  readManifest(
    "https://dwxmfgxgcusc8.cloudfront.net/gallery/manifest.json"
  ).then((result) => setImages(result.assets ?? []));

  return (
    <MiddleBlockSection>
      <Row justify="center" align="middle">
        <ContentWrapper>
          <Col lg={24} md={24} sm={24} xs={24}>
            <h6
              style={{
                fontFamily: "'seasons', 'Motiva Sans Bold', 'serif'",
                fontWeight: "bold",
                color: primaryHeaderColor,
              }}
            >
              Gallery
            </h6>
            {QuiltedImageList(images)}
          </Col>
        </ContentWrapper>
      </Row>
    </MiddleBlockSection>
  );
}

export default Gallery;
